import React, { useState, useReducer, useEffect } from "react";
import NonTitledForm from "../AssetNonTitled/AssetNonTitledForm";
import SellingDetails from "../SellingDetails";
import PriceDigest from "../PriceDigest";
import TrailerForm from "../AssetTrailerForm";
import AssetTruckChassis from "../AssetTruckChassis";
import AssetTruckBody from "../AssetTruckBody";
import AssetTypeNotSupported from "../AssetTypeNotSupported";
import Vendor from "../Vendor";
import { useStyles } from "./AssetDetailsFormStyles";
import { Edit, Cancel, Save } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import {
	Box,
	Divider,
	Grid,
	IconButton,
	Tooltip,
	Typography,
} from "@material-ui/core";
import { assetReducer, actions, initialConditions } from "../AssetReducer";
import useAssetProvider from "../useAssetProvider";
import { applicationTitles } from "../../Constants/utils"


const AssetDetail = ({ asset, handelCollapse }) => {
	let ui;
	const {
		isReadOnly,
		assets,
		updateAssets,
		onAssetUpdate,
		onAssetDuplicate,
		getPDConfig,
		getPDValue,
		getEWConfig,
		getEWValue,
	} = useAssetProvider();
	const [[newAsset, conditions], dispatch] = useReducer(assetReducer, [
		{ ...asset, pd_values: {} },
		initialConditions,
	]);
	const [assetDefault, setAssetDefault] = useState(asset);
	const [headerText, setHeaderText] = useState("");
	const [error, setError] = useState(false)
	const [currentVendor, setCurrentVendor] = useState({
		id: "",
		name: newAsset?.vendor,
		address: `${newAsset?.vendor_street} ${newAsset?.vendor_city} ${newAsset?.vendor_state} ${newAsset?.vendor_country} ${newAsset?.vendor_zip}`
	});
	const [notSupported, setNotSupported] = useState(false);
	const [isDuplicate, setDuplicate] = useState(false);
	const classes = useStyles();

	useEffect(() => {
		if (asset) {
			const assetDetail = { ...asset }

			dispatch({
				type: actions.INIT_ASSET,
				payload: assetDetail,
			});
			if (!asset.is_trade_in && !asset.is_collateral)
				setHeaderText("Selling Price");
			else if (asset.is_trade_in && !asset.is_collateral)
				setHeaderText("Trade in Amount");
			else if (!asset.is_trade_in && asset.is_collateral)
				setHeaderText("Collateral Amount");
			else if (asset.is_pledge) setHeaderText("Pledged Amount");
			if (
				asset.type !== "Trailer" &&
				asset.type !== "Truck - Chassis Only" &&
				asset.type !== "Truck with Body" &&
				asset.type !== "Non-Titled"
			) {
				setNotSupported(true);
			}
		}
		setDuplicate(asset?.id?.includes("duplicate"));
	}, [asset]);


	useEffect(() => {
		let timeOut = null
		if (error) {
			timeOut = setTimeout(() => {

				setError(false)

			}, 1500)
		}
		return (() => {
			clearTimeout(timeOut)
			const assetDetail = { ...asset }
			dispatch({
				type: actions.INIT_ASSET,
				payload: assetDetail,
			});
		})
	}, [asset, error])


	const checkEditAccess = () => {
		const titleArray = document.title.split(" -", 1);
		let title = titleArray[0];
		if (title) {
			let access = applicationTitles.some((item) => item === document.title);
			return !access;
		}

		return true;
	};

	const reset = () => {
		dispatch({
			type: actions.RESET,
		});
	};

	const overrideVIN = (data) => {
		dispatch({
			type: actions.OVERRIDE_VIN,
			payload: data,
		});
	};

	const overrideSerialNumber = (data) => {
		dispatch({
			type: actions.OVERRIDE_SERIAL_NUMBER,
			payload: data,
		});
	};

	const overrideYear = (data) => {
		dispatch({
			type: actions.OVERRIDE_YEAR,
			payload: data,
		});
	};

	const overrideMake = (data) => {
		dispatch({
			type: actions.OVERRIDE_MAKE,
			payload: data,
		});
	};

	const overrideModel = (data) => {
		dispatch({
			type: actions.OVERRIDE_MODEL,
			payload: data,
		});
	};

	const overrideNoVinFound = (data) => {
		dispatch({
			type: actions.UPDATE_NO_VIN_FOUND,
			payload: data
		})
	}

	const findByVin = async (vin_id) => {
		if (vin_id) {
			try {
				const response = await getPDConfig({
					VIN: vin_id,
				});
				if (response.length) {
					dispatch({
						type: actions.SET_OVERRIDE_VIN,
						payload: {
							data: response[0],
						},
					});

					const configurations = [];
					await Promise.all(
						response.map(async (item) => {
							const config = await getPDConfig({
								configurationId: item.configurationId,
							});
							configurations.push(config);
						})
					);

					const updatedConfigs = [];
					configurations.map((item) => {
						const specs = item.specs;
						const specification = {};
						specs.map((spec) => {
							specification[spec.specName] = spec.specValue;
						});
						updatedConfigs.push({ ...item, specs: specification });
					});
					dispatch({
						type: actions.SET_CONFIG_CHOICES,
						payload: updatedConfigs,
					});
				} else {
					//alert("Data not found");
					reset();
					setError(true);
				}
			} catch (error) {
				// alert(error.message);
				reset();
				setError(true);
			}
		} else {
			reset();
			loadYearChoices();
		}
	};

	const findEWBySN = async (serialNumber) => {
		if (serialNumber) {
			try {
				const response = await getEWConfig({
					serialNumber: serialNumber,
				});
				if (response) {
					dispatch({
						type: actions.SET_OVERRIDE_SERIAL_NUMBER,
						payload: response,
					});
				} else {
					reset();
				}
			} catch (error) {
				alert(error.message);
				reset();
			}
		} else {
			reset();
		}
	};

	const loadYearChoices = () => dispatch({ type: actions.SET_YEAR_CHOICES });

	const setManualEdit = (payload) =>
		dispatch({ type: actions.SET_MANUAL_OVERRIDE, payload });

	const disableManualEdit = () =>
		dispatch({ type: actions.DISABLE_MANUAL_OVERRIDE });

	const loadEWYearChoices = () =>
		dispatch({ type: actions.LOAD_EW_YEAR_CHOICES });

	const loadCategoryChoices = async (overrideYear, calssId) => {
		// console.log("***LOAD Category CHOICES***");
		console.log(" OVERRIDE_YEAR  ", overrideYear);
		dispatch({
			type: actions.OVERRIDE_YEAR,
			payload: overrideYear,
		});

		try {
			const response = await getPDConfig({
				year: overrideYear,
				classid: calssId,
			});
			if (response.length) {
				dispatch({
					type: actions.SET_CATEGORY_CHOICES,
					payload: response,
				});
			} else {
				setManualCategory(true);
			}
		} catch (error) {
			setManualCategory(true);
		}
	};

	const loadTruckBodyCategoryChoices = async (overrideYear, calssId) => {
		// console.log("***LOAD Category CHOICES***");
		dispatch({
			type: actions.OVERRIDE_TRUCK_BODY_YEAR,
			payload: overrideYear,
		});

		try {
			const response = await getPDConfig({
				year: overrideYear,
				classid: calssId,
			});
			if (response.length) {
				dispatch({
					type: actions.SET_TRUCK_BODY_CATEGORY_CHOICES,
					payload: response,
				});
			} else {
				setManualCategory(true);
			}
		} catch (error) {
			setManualCategory(true);
		}
	};

	const loadMakeChoices = async (category, calssId) => {
		//console.log("***LOAD MAKE CHOICES***");
		dispatch({
			type: actions.PD_OVERRIDE_CATEGORY,
			payload: {
				categoryId: category.categoryId,
				categoryName: category.categoryName,
			},
		});

		try {
			const response = await getPDConfig({
				year: newAsset.override_year,
				classid: calssId,
				categoryId: category.categoryId,
			});
			if (response.length) {
				dispatch({
					type: actions.SET_MAKE_CHOICES,
					payload: response,
				});
			} else {
				// alert("Data not found");
				setManualMake(true);
			}
		} catch (error) {
			// alert(error.message);
			setManualMake(true);
		}
	};

	const loadTruckBodyMakeChoices = async (category, calssId) => {
		//console.log("***LOAD MAKE CHOICES***");
		dispatch({
			type: actions.PD_OVERRIDE_TRUCK_BODY_CATEGORY,
			payload: {
				categoryId: category.categoryId,
				categoryName: category.categoryName,
			},
		});

		try {
			const response = await getPDConfig({
				year: newAsset.override_truck_body_year,
				classid: calssId,
				categoryId: category.categoryId,
			});
			if (response.length) {
				dispatch({
					type: actions.SET_TRUCK_BODY_MAKE_CHOICES,
					payload: response,
				});
			} else {
				// alert("Data not found");
				setManualMake(true);
			}
		} catch (error) {
			// alert(error.message);
			setManualMake(true);
		}
	};

	const loadEWMakeChoices = async (serialNumber, overrideYear) => {
		try {
			const response = await getEWConfig({
				serialNumber: serialNumber,
				year: overrideYear,
			});
			if (response) {
				dispatch({
					type: actions.SET_MAKE_CHOICES,
					payload: response,
				});
			} else {
				setManualMake(true);
			}
		} catch (error) {
			setManualMake(true);
		}
	};

	const loadModelChoices = async (makeName, calssId) => {
		//console.log("***LOAD MODEL CHOICES***");
		dispatch({
			type: actions.OVERRIDE_MAKE,
			payload: makeName,
		});

		try {
			const response = await getPDConfig({
				year: newAsset.override_year,
				classid: calssId,
				categoryId: newAsset.pd_override_categoryid,
				manufacturer: makeName,
			});
			if (response.length) {
				dispatch({
					type: actions.SET_MODEL_CHOICES,
					payload: response,
				});
			} else {
				// alert("Data not found");
				setManualModel(true);
			}
		} catch (error) {
			// alert(error.message);
			setManualModel(true);
		}
	};

	const loadTruckBodyModelChoices = async (makeName, calssId) => {
		//console.log("***LOAD MODEL CHOICES***");
		dispatch({
			type: actions.OVERRIDE_TRUCK_BODY_MAKE,
			payload: makeName,
		});

		try {
			const response = await getPDConfig({
				year: newAsset.override_truck_body_year,
				classid: calssId,
				categoryId: newAsset.pd_truck_body_override_categoryid,
				manufacturer: makeName,
			});
			if (response?.length) {
				dispatch({
					type: actions.SET_TRUCK_BODY_MODEL_CHOICES,
					payload: response,
				});
			}
		} catch (error) {
			setManualModel(true);
		}
	};

	const loadEWModelChoices = async (data) => {
		dispatch({
			payload: data,
			type: actions.OVERRIDE_MAKE,
		});

		try {
			const response = await getEWConfig({
				serialNumber: newAsset.serial_number,
				manufacturer: data,
			});

			if (response.length) {
				dispatch({
					type: actions.SET_MODEL_CHOICES,
					payload: response,
				});
			} else {
				// alert("Data not found");
				setManualModel(true);
			}
		} catch (error) {
			// alert(error.message);
			setManualModel(true);
		}
	};

	const loadConfigChoices = async (modelName, calssId) => {
		dispatch({
			type: actions.OVERRIDE_MODEL,
			payload: modelName,
		});

		try {
			const response = await getPDConfig({
				year: newAsset.override_year,
				classid: calssId,
				categoryId: newAsset.pd_override_categoryid,
				manufacturer: newAsset.override_make,
				modelName: modelName,
			});
			if (response.length) {
				const configurations = [];
				await Promise.all(
					response.map(async (item) => {
						const config = await getPDConfig({
							configurationId: item.configurationId,
						});
						configurations.push(config);
					})
				);

				const updatedConfigs = [];
				configurations.map((item) => {
					const specs = item.specs;
					const specification = {};
					specs.map((spec) => {
						specification[spec.specName] = spec.specValue;
					});
					updatedConfigs.push({ ...item, specs: specification });
				});
				dispatch({
					type: actions.SET_CONFIG_CHOICES,
					payload: updatedConfigs,
				});
			} else {
				// alert("data not found. Please input manually");
				setManualConfig(true);
			}
		} catch (error) {
			setManualConfig(true);
		}
	};

	const loadTruckBodyConfigChoices = async (modelName, calssId) => {
		dispatch({
			type: actions.OVERRIDE_TRUCK_BODY_MODEL,
			payload: modelName,
		});

		try {
			const response = await getPDConfig({
				year: newAsset.override_truck_body_year,
				classid: calssId,
				categoryId: newAsset.pd_truck_body_override_categoryid,
				manufacturer: newAsset.override_truck_body_make,
				modelName: modelName,
			});

			if (response.length) {
				const configurations = [];
				await Promise.all(
					response.map(async (item) => {
						const config = await getPDConfig({
							configurationId: item.configurationId,
						});
						configurations.push(config);
					})
				);

				const updatedConfigs = [];
				configurations.map((item) => {
					const specs = item.specs;
					const specification = {};
					specs.map((spec) => {
						specification[spec.specName] = spec.specValue;
					});
					updatedConfigs.push({ ...item, specs: specification });
				});
				dispatch({
					type: actions.SET_TRUCK_BODY_CONFIG_CHOICES,
					payload: updatedConfigs,
				});
			} else {
				// alert("data not found. Please input manually");
				setManualConfig(true);
			}
		} catch (error) {
			setManualConfig(true);
		}
	};

	const loadEWConfigChoices = async (data) => {
		dispatch({
			type: actions.OVERRIDE_MODEL,
			payload: data.modelName,
		});

		try {
			const response = await getEWConfig({
				serialNumber: newAsset.serialnumber,
				//classid: '',
				categoryId: data.categoryId,
				manufacturer: newAsset.override_make,
				model: data.modelName,
			});
			if (response.length) {
				dispatch({
					type: actions.SET_CONFIG_CHOICES,
					payload: response,
				});
			} else {
				// alert("data not found. Please input manually");
				setManualConfig(true);
			}
		} catch (error) {
			setManualConfig(true);
		}
	};

	const setTrailerAssetConfig = (configId) => {
		conditions.configChoices.map((config) => {
			if (configId === config.configurationId) {
				dispatch({
					type: actions.OVERRIDE_DESCRIPTION,
					payload: {
						configurationId: configId,
						override_des: config.specs.length
							? `${config.specs.length} ${config.categoryName}`
							: config.categoryName,
					},
				});
			}
		});
	};

	const setTruckChassisAssetConfig = (configId) => {
		conditions.configChoices.map((config) => {
			if (configId === config.configurationId) {
				dispatch({
					type: actions.SET_MANUFACTURER_MODEL,
					payload: config,
				});
			}
		});
	};

	const setAssetConfig = (configId, classId) => {
		for (let item of conditions.configChoices) {
			if (configId === item.configurationId) {
				if (classId === 2) {
					dispatch({
						type: actions.SET_MANUFACTURER_MODEL,
						payload: item,
					});
				} else if (classId === 7) {
					dispatch({
						type: actions.OVERRIDE_DESCRIPTION,
						payload: {
							configurationId: configId,
							override_des: item.specs.length
								? `${item.specs.length} ${item.categoryName}`
								: item.categoryName,
						},
					});
				} else {
					dispatch({
						type: actions.RESET,
					});
				}
			}
		}
	};

	const setTruckBodyAssetConfig = (config) => {
		if (config) {
			dispatch({
				type: actions.OVERRIDE_TRUCK_BODY_DESCRIPTION,
				payload: config,
			});
		}
	};

	const setEWAssetConfig = (config) => {
		dispatch({
			type: actions.OVERRIDE_EW_DESCRIPTION,
			payload: config,
		});
	};

	const setOverrideEWDescription = (data) => {
		dispatch({
			type: actions.SET_OVERRIDE_EW_DESCRIPTION,
			payload: data,
		});
	};

	const setOverrideCondition = (condition) => {
		dispatch({
			type: actions.OVERRIDE_CONDITION,
			payload: condition,
		});
	};

	const setOverrideHours = (hours) => {
		dispatch({
			type: actions.OVERRIDE_HOURS,
			payload: hours,
		});
	};

	const setOverrideMileage = (mileage) => {
		dispatch({
			type: actions.OVERRIDE_MILEAGE,
			payload: mileage,
		});
	};

	const setSearchVIN = (data) => {
		dispatch({
			type: actions.SEARCH_VIN,
			payload: data,
		});
	};

	const setManualYear = () => {
		dispatch({
			type: actions.IS_MANUAL_YEAR,
			payload: true,
		});
	};

	const setManualCategory = (data) => {
		dispatch({
			type: actions.IS_MANUAL_CATEGORY,
			payload: data,
		});
	};

	const setManualMake = (data) => {
		dispatch({
			type: actions.IS_MANUAL_MAKE,
			payload: data,
		});
	};

	const setManualModel = (data) => {
		dispatch({
			type: actions.IS_MANUAL_MODEL,
			payload: data,
		});
	};

	const setManualConfig = (data) => {
		dispatch({
			type: actions.IS_MANUAL_CONFIG,
			payload: data,
		});
	};

	const selectEWYear = (data) => {
		dispatch({
			type: actions.OVERRIDE_YEAR,
			payload: data,
		});
	};

	const saveMake = () => {
		dispatch({
			type: actions.SAVE_MAKE,
		});
	};

	const saveEWYear = () => reset();

	const verifyEWMake = async () => {
		try {
			const response = await getEWConfig({
				manufacturer: newAsset.override_make,
			});
			//console.log("res check", response, response[0].manufacturer);
			if (response.length) {
				loadEWModelChoices(response[0].manufacturerName);
			} else {
				setManualModel(true);
			}
		} catch (error) {
			//addError(error.message)
			// alert(error.message);
			setManualModel(true);
		}
	};

	const verifyEWModel = async () => {
		try {
			const response = await getEWConfig({
				manufacturer: newAsset.override_make,
				model: newAsset.override_model,
			});
			if (response.length) {
				if (response.length === 1) {
					setEWAssetConfig(response[0]);
				} else {
					dispatch({
						type: actions.SET_CONFIG_CHOICES,
						payload: response,
					});
				}
			} else {
				dispatch({
					type: actions.SET_MODEL_MANUAL,
					payload: response,
				});
				setManualModel(false);
				setManualConfig(true);
			}
		} catch (error) {
			//addError(error.message)
			// alert(error.message);
			setManualConfig(true);
		}
	};

	const editAssetDetails = (data) => {
		dispatch({
			type: actions.EDIT_ASSET_DETAILS,
			payload: data,
		});
	};

	const deleteAssetOverride = (data) => {
		dispatch({
			type: actions.DELETE_ASSET_OVERRIDE,
			payload: data,
			initialAsset: assetDefault,
		});
	};

	const ediTruckBodyAssetDetails = (data) => {
		dispatch({
			type: actions.EDIT_TRUCK_BODY_ASSET_DETAILS,
			payload: data,
			initialAsset: assetDefault,
		});
	};

	const executeDuplicateFunction = async (condition) => {
		if (!condition) {
			const assetIndex = assets.findIndex((item) => item.id === asset.id);
			const min = 1;
			const max = 100;
			const randomId = min + Math.random() * (max - min);
			const newAsset = { ...asset, id: `duplicate-${randomId}` };
			// delete newAsset.id;
			const newAssets = [
				...assets.slice(0, assetIndex + 1),
				newAsset,
				...assets.slice(assetIndex + 1),
			];
			try {
				updateAssets(newAssets);
				handelCollapse(newAsset)
			} catch (err) {
				console.log(" Log context error ", err);
			}

		} else {
			try {
				delete asset?.id;
				onAssetDuplicate(asset);
			} catch (err) {
				console.log(" Log context error ", err);
			}
		}
	};

	function isIncomplete(updatedAsset) {
		if (updatedAsset.is_trade_in || updatedAsset.is_collateral) return false;
		if (updatedAsset.override_year == null) return true;
		if (updatedAsset.override_make == null) return true;
		if (updatedAsset.override_model == null) return true;
		if (
			updatedAsset.override_hours == 0 &&
			updatedAsset.override_mileage == 0 &&
			updatedAsset?.primary_condition == "Used"
		)
			return true;

		return false;
	}

	const updateAssetPrices = async (type) => {
		if (newAsset) {
			const updatedAsset = { ...newAsset };
			let catchErr = null;
			if (type === "Non-Titled") {
				try {
					const response = await getEWValue({
						modelId: newAsset.pd_override_configurationid,
						year: newAsset.override_year || "",
						usage: newAsset.override_hours || "",
					});
					if (response) {
						updatedAsset.override_retail_price =
							response.adjustedFmv || response.unadjustedFmv;
						updatedAsset.override_trade_in_high =
							response.adjustedOlv || response.unadjustedOlv;
						updatedAsset.pd_override_finance_value =
							response.adjustedFlv || response.unadjustedFlv;
					}
				} catch (error) {
					catchErr = error;
					updatedAsset.override_retail_price = 0;
					updatedAsset.override_trade_in_high = 0;
					updatedAsset.pd_override_finance_value = 0;
				}
			} else if (type === "Body") {
				try {
					const response = await getPDValue({
						configurationId:
							newAsset.pd_truck_body_override_configurationid ||
							newAsset.pd_truck_body_configurationid,
						condition: "",
						usage: newAsset.override_mileage,
						tense: "CURRENT",
					});
					if (response) {
						updatedAsset.override_truck_body_retail_price =
							response.adjustedRetail || response.unadjustedRetail;
						updatedAsset.override_truck_body_wholesale_price =
							response.adjustedWholesale || response.unadjustedWholesale;
						updatedAsset.pd_truck_body_override_finance_value =
							response.adjustedFinance || response.unadjustedFinance;
					}
				} catch (error) {
					catchErr = error;
					updatedAsset.override_truck_body_retail_price = 0;
					updatedAsset.override_truck_body_wholesale_price = 0;
					updatedAsset.pd_truck_body_override_finance_value = 0;
					updatedAsset.nmef_value = 0;
				}
			} else {
				try {
					const response = await getPDValue({
						configurationId: newAsset.pd_override_configurationid,
						condition: "",
						usage: newAsset.override_mileage,
						tense: "CURRENT",
					});
					if (response) {
						updatedAsset.override_retail_price =
							response.adjustedRetail || response.unadjustedRetail;
						updatedAsset.override_trade_in_high =
							response.adjustedWholesale || response.unadjustedWholesale;
						updatedAsset.pd_override_finance_value =
							response.adjustedFinance || response.unadjustedFinance;
					}
				} catch (error) {
					catchErr = error;
					console.error(error);
				}
			}

			updatedAsset.override_year = updatedAsset.override_year || "";
			updatedAsset.override_make = updatedAsset.override_make || "";
			updatedAsset.override_model = updatedAsset.override_model || "";
			updatedAsset.is_incomplete = isIncomplete(updatedAsset);
			// if (!catchErr)
			onAssetUpdate(updatedAsset);
		}
	};

	const loadFunction = (action) => {
		switch (action.functionName) {
			case actions.OVERRIDE_VIN:
				return overrideVIN();
			case actions.OVERRIDE_SERIAL_NUMBER:
				return overrideSerialNumber(action.data);
			case actions.OVERRIDE_YEAR:
				return overrideYear(action.data);
			case actions.OVERRIDE_MAKE:
				return overrideMake(action.data);
			case actions.OVERRIDE_MODEL:
				return overrideModel(action.data);
			case actions.OVERRIDE_EW_DESCRIPTION:
				return setEWAssetConfig(action.data);
			case actions.FIND_BY_VIN:
				return findByVin(action.data);
			case actions.FIND_EW_BY_SN:
				return findEWBySN(action.data);
			case actions.LOAD_YEAR_CHOICES:
				return loadYearChoices(action.data);
			case actions.LOAD_EW_YEAR_CHOICES:
				return loadEWYearChoices();
			case actions.LOAD_CATEGORY_CHOICES:
				return loadCategoryChoices(action.data);
			case actions.LOAD_TRUCK_BODY_CATEGORY_CHOICES:
				return loadTruckBodyCategoryChoices(action.data);
			case actions.LOAD_MAKE_CHOICES:
				return loadMakeChoices(action.data);
			case actions.LOAD_TRUCK_BODY_MAKE_CHOICES:
				return loadTruckBodyMakeChoices(action.data);
			case actions.LOAD_EW_MAKE_CHOICES:
				return loadEWMakeChoices(action.serialNumber, action.year);
			case actions.LOAD_MODEL_CHOICES:
				return loadModelChoices(action.data);
			case actions.LOAD_TRUCK_BODY_MODEL_CHOICES:
				return loadTruckBodyModelChoices(action.data);
			case actions.LOAD_EW_MODEL_CHOICES:
				return loadEWModelChoices(action.data);
			case actions.LOAD_CONFIG_CHOICES:
				return loadConfigChoices(action.data);
			case actions.LOAD_TRUCK_BODY_CONFIG_CHOICES:
				return loadTruckBodyConfigChoices(action.data);
			case actions.LOAD_EW_CONFIG_CHOICES:
				return loadEWConfigChoices(action.data);
			case actions.SET_SEARCH_VIN:
				return setSearchVIN(action.data);
			case actions.SET_TRAILER_ASSET_CONFIG:
				return setTrailerAssetConfig(action.data);
			case actions.SET_TRUCK_CHASSIS_ASSET_CONFIG:
				return setTruckChassisAssetConfig(action.data);
			case actions.SET_TRUCK_BODY_ASSET_CONFIG:
				return setTruckBodyAssetConfig(action.data);
			case actions.SET_OVERRIDE_EW_DESCRIPTION:
				return setOverrideEWDescription(action.data);
			case actions.SET_OVERRIDE_CONDITION:
				return setOverrideCondition(action.data);
			case actions.SET_OVERRIDE_HOURS:
				return setOverrideHours(action.data);
			case actions.SET_OVERRIDE_MILEAGE:
				return setOverrideMileage(action.data);
			case actions.IS_MANUAL_YEAR:
				return setManualYear();
			case actions.SELECT_EW_YEAR:
				return selectEWYear(action.data);
			case actions.IS_MANUAL_MAKE:
				return setManualMake(action.data);
			case actions.IS_MANUAL_MODEL:
				return setManualModel(action.data);
			case actions.IS_MANUAL_CONFIG:
				return setManualConfig(action.data);
			case actions.SAVE_EW_YEAR:
				return saveEWYear();
			case actions.SAVE_MAKE:
				return saveMake();
			case actions.VERIFY_EW_MAKE:
				return verifyEWMake();
			case actions.VERIFY_EW_MODEL:
				return verifyEWModel();
			case actions.EDIT_ASSET_DETAILS:
				return editAssetDetails(action.data);
			case actions.EDIT_TRUCK_BODY_ASSET_DETAILS:
				return ediTruckBodyAssetDetails(action.data);
			case actions.DELETE_ASSET_OVERRIDE:
				return deleteAssetOverride(action.data);
			default:
				return null;
		}
	};

	let isTruckBody = false;

	if (asset.type === "Non-Titled")
		ui = (
			<NonTitledForm
				asset={newAsset}
				conditions={conditions}
				isReadOnly={isReadOnly}
				loadFunction={loadFunction}
			/>
		);
	else if (
		asset.type === "Truck - Chassis Only" ||
		asset.type === "Truck with Body"
	) {
		ui = (
			<AssetTruckChassis
				asset={newAsset}
				conditions={conditions}
				isReadOnly={isReadOnly}
				loadFunction={loadFunction}
				findByVin={findByVin}
				loadYearChoices={loadYearChoices}
				loadCategoryChoices={loadCategoryChoices}
				loadMakeChoices={loadMakeChoices}
				loadModelChoices={loadModelChoices}
				loadConfigChoices={loadConfigChoices}
				setAssetConfig={setAssetConfig}
				dispatch={dispatch}
				setOverrideCondition={setOverrideCondition}
				setOverrideMileage={setOverrideMileage}
				setMaualOverride={setManualEdit}
				disableManualEdit={disableManualEdit}
				setOverrideNoVinFound={overrideNoVinFound}
				error={error}
			/>
		);

		if (asset.type === "Truck with Body") isTruckBody = true;
	} else if (asset.type === "Trailer")
		ui = (
			<TrailerForm
				asset={newAsset}
				conditions={conditions}
				overrideYear={newAsset?.override_year}
				loadFunction={loadFunction}
				findByVin={findByVin}
				loadYearChoices={loadYearChoices}
				loadCategoryChoices={loadCategoryChoices}
				loadMakeChoices={loadMakeChoices}
				loadModelChoices={loadModelChoices}
				loadConfigChoices={loadConfigChoices}
				setAssetConfig={setAssetConfig}
				dispatch={dispatch}
				setOverrideCondition={setOverrideCondition}
				setOverrideHours={setOverrideHours}
				setMaualOverride={setManualEdit}
				disableManualEdit={disableManualEdit}
				setOverrideNoVinFound={overrideNoVinFound}
				error={error}
			/>
		);
	else ui = <AssetTypeNotSupported />;

	// const isDuplicate = asset?.id === null || asset?.id === undefined;

	return (
		<Box>
			<Grid container direction="row">
				<Grid item xs={6}>
					<Grid container direction="row" alignItems="flex-end">
						<Grid item xs={5} align="left">
							<Typography variant="subtitle2" style={{ marginLeft: ".25rem" }}>
								Original
							</Typography>
						</Grid>
						<Grid item xs={5} align="left">
							<Typography variant="subtitle2" style={{ marginLeft: ".25rem" }}>
								Override
							</Typography>
						</Grid>
						<Grid item xs={2} />
					</Grid>
				</Grid>
				<Grid item xs={3}>
					<Grid container>
						<Grid item xs={12} align="center">
							<Typography variant="subtitle2">
								{newAsset.type === "Non-Titled"
									? "EquipmentWatch Values"
									: "PriceDigests Values"}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={3}>
					<Typography variant="subtitle2">{headerText}</Typography>
				</Grid>
			</Grid>
			<Divider style={{ margin: ".5rem 0" }} />
			<Grid container direction="row" spacing={1}>
				<Grid item xs={9}>
					<Grid container direction="row" spacing={1} className={classes.boxDesign}>
						<Grid item xs={8} align="center" className={classes.innerBoxDesign}>
							<Grid container direction="row">
								<Grid item xs={10} className={classes.borderBottom}>
									<Typography variant="subtitle2" align="left">
										{asset.type} Details
									</Typography>
								</Grid>
							</Grid>
							{ui}
							<Grid container direction="row" alignItems="flex-end">
								{!isReadOnly && !notSupported && !conditions.edit_asset && checkEditAccess() && (
									<Grid item xs={12} align="right">
										<Tooltip title="Edit" placement="top">
											<IconButton
												color="primary"
												onClick={() => {
													loadFunction({
														functionName: actions.EDIT_ASSET_DETAILS,
														data: true,
													});
												}}>
												<Edit />
											</IconButton>
										</Tooltip>
									</Grid>
								)}

								{!isReadOnly && conditions.edit_asset && (
									<Grid item xs={12} align="right">
										<Tooltip title="Cancel" placement="top">
											<IconButton
												color="secondary"
												onClick={() => {
													loadFunction({
														functionName: actions.DELETE_ASSET_OVERRIDE,
														data: false,
													});
												}}>
												<Cancel />
											</IconButton>
										</Tooltip>
										<Tooltip title="Save" placement="top">
											<IconButton
												color="primary"
												onClick={() => {
													loadFunction({
														functionName: actions.EDIT_ASSET_DETAILS,
														data: false,
													});
													updateAssetPrices(newAsset.type);
												}}>
												<Save />
											</IconButton>
										</Tooltip>
									</Grid>
								)}
							</Grid>
						</Grid>
						<Grid item xs={4} align="center">
							<PriceDigest detail={newAsset.pd_values.vehicleItem || {}} />
						</Grid>
					</Grid>
					{isTruckBody && (
						<>
							<Grid
								container
								direction="row"
								spacing={1}
								className={classes.boxDesign}>
								<Grid item xs={8} className={classes.innerBoxDesign}>
									<Grid container direction="row">
										<Grid item xs={10} className={classes.borderBottom}>
											<Typography variant="subtitle2" align="left">
												Body details
											</Typography>
										</Grid>
									</Grid>
									<AssetTruckBody
										details={asset}
										asset={newAsset}
										conditions={conditions}
										loadFunction={loadFunction}
										loadYearChoices={loadYearChoices}
										loadTruckBodyCategoryChoices={loadTruckBodyCategoryChoices}
										loadTruckBodyMakeChoices={loadTruckBodyMakeChoices}
										loadTruckBodyModelChoices={loadTruckBodyModelChoices}
										loadTruckBodyConfigChoices={loadTruckBodyConfigChoices}
										setTruckBodyAssetConfig={setTruckBodyAssetConfig}
										dispatch={dispatch}
									/>
									<Grid container direction="row" alignItems="flex-end">
										{!isReadOnly && !conditions.edit_truck_body && checkEditAccess() && (
											<Grid item xs={12} align="right">
												<Tooltip title="Edit" placement="top">
													<IconButton
														color="primary"
														onClick={() => {
															loadFunction({
																functionName: actions.EDIT_TRUCK_BODY_ASSET_DETAILS,
																data: true,
															});
														}}>
														<Edit />
													</IconButton>
												</Tooltip>
											</Grid>
										)}

										{!isReadOnly && conditions.edit_truck_body && (
											<Grid item xs={12} align="right">
												<Tooltip title="Cancel" placement="top">
													<IconButton
														color="secondary"
														onClick={() => {
															loadFunction({
																functionName: actions.EDIT_TRUCK_BODY_ASSET_DETAILS,
																data: false,
															});
														}}>
														<Cancel />
													</IconButton>
												</Tooltip>
												<Tooltip title="Save" placement="top">
													<IconButton
														color="primary"
														onClick={() => {
															loadFunction({
																functionName: actions.EDIT_TRUCK_BODY_ASSET_DETAILS,
																data: false,
															});
															updateAssetPrices("Body");
														}}>
														<Save />
													</IconButton>
												</Tooltip>
											</Grid>
										)}
									</Grid>
								</Grid>
								<Grid item xs={4}>
									<PriceDigest detail={newAsset.pd_values.bodyItem || {}} />
								</Grid>
							</Grid>
						</>
					)}
					<Grid container direction="row" spacing={1} className={classes.boxDesign}>
						<Grid item xs={8}>
							{!isReadOnly && checkEditAccess() ? (
								<Box display="flex" alignItems="baseline" marginLeft={1}>
									<Button
										style={{
											backgroundColor: "#022F40",
											color: "white",
										}}
										className={classes.cloneButton}
										onClick={() => {
											executeDuplicateFunction(isDuplicate);
										}}>
										{!isDuplicate ? "Duplicate Asset" : "Save Duplicate Asset"}
									</Button>
								</Box>
							) : null}
						</Grid>
						<Grid item xs={4}>
							<PriceDigest detail={newAsset.pd_values.totalItem || {}} />
						</Grid>
					</Grid>
					<Grid container direction="row" spacing={1} className={classes.boxDesign}>
						<Grid item xs={12}>
							<Vendor
								notSupported={notSupported}
								asset={asset}
								currentVendor={currentVendor}
								currentLocation={asset?.location_id}
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={3} align="center">
					<SellingDetails details={asset} notSupported={notSupported} checkAssestEditAccess={checkEditAccess()} />
				</Grid>
			</Grid>
		</Box>
	);
};
export default AssetDetail;
